import { Flex, Table } from "antd"
import ReactCountryFlag from "react-country-flag"
import { MoneyLabel } from "../../atoms/formatters/MoneyLabel"
import { PercentLabel } from "../../atoms/formatters/PercentLabel"
import { SimpleRoundedValueLabel } from "../../atoms/formatters/SimpleRoundedValueLabel"

export const AssetDistributionByStructureTable = ({ data }) => {
  const total = data.reduce((sum, item) => sum + item.value_usd, 0)

  const columns = [
    {
      title: "Structure",
      dataIndex: "dim_bank_account",
      align: "center",
      render: (bankAccount) => bankAccount?.structure_path.slice(0, -1).join(" > "),
    },
    {
      title: "Bank Account",
      dataIndex: "dim_bank_account",
      align: "center",
      render: (bankAccount) => {
        const countryCode = bankAccount?.country_code
        const country = bankAccount?.country

        return (
          <Flex style={{ alignItems: "center", justifyContent: "center" }}>
            {countryCode && <ReactCountryFlag countryCode={countryCode} style={{ width: 18 }} title={country} svg />}
            <span style={{ marginLeft: 8 }}>{bankAccount?.structure_path.slice(-1)[0]}</span>
          </Flex>
        )
      },
    },
    {
      title: "Value (USD)",
      dataIndex: "value_usd",
      render: (value) => <MoneyLabel value={value} currency="USD" />,
      align: "center",
    },
    {
      title: "Value (BRL)",
      dataIndex: "value_brl",
      render: (value) => <MoneyLabel value={value} currency="BRL" />,
      align: "center",
    },
    {
      title: "Quantity (#)",
      dataIndex: "quantity",
      align: "center",
      render: (value) => <SimpleRoundedValueLabel value={value} />,
    },
    {
      title: "%",
      dataIndex: "value_usd",
      render: (value) => <PercentLabel value={value / total} decimalPlaces={2} />,
      align: "center",
    },
    // {
    //   title: "",
    //   dataIndex: "dim_bank_account",
    //   align: "center",
    //   width: 150,
    //   render: (dimBankAccount) => {
    //     const restrictions = dimBankAccount?.restrictions

    //     if (restrictions) {
    //       return (
    //         <Tooltip title={restrictions}>
    //           <Alert message="Account Restricted" type="warning" showIcon />
    //         </Tooltip>
    //       )
    //     }

    //     return (
    //       <Flex gap={spaces.space1}>
    //         <Tooltip title={restrictions}>
    //           <Button type="primary" icon={<ImportOutlined />} style={{ backgroundColor: colors.green }} disabled={!!restrictions}>
    //             Buy
    //           </Button>
    //         </Tooltip>
    //         <Tooltip title={restrictions}>
    //           <Button type="primary" icon={<ExportOutlined />} style={{ backgroundColor: colors.red }} disabled={!!restrictions}>
    //             Sell
    //           </Button>
    //         </Tooltip>
    //         <Tooltip title={restrictions}>
    //           <Button type="primary" icon={<CloseOutlined />} style={{ backgroundColor: "red" }} disabled={!!restrictions}>
    //             Close
    //           </Button>
    //         </Tooltip>
    //       </Flex>
    //     )
    //   },
    // },
  ]

  const footer = () => (
    <Table.Summary>
      <Table.Summary.Row>
        <Table.Summary.Cell index={0} align="center">
          <b>Total</b>
        </Table.Summary.Cell>
        <Table.Summary.Cell index={1} align="center"></Table.Summary.Cell>
        <Table.Summary.Cell index={2} align="center">
          <b>
            <MoneyLabel value={data?.reduce((sum, item) => sum + item.value_usd, 0)} currency="USD" />
          </b>
        </Table.Summary.Cell>
        <Table.Summary.Cell index={3} align="center">
          <b>
            <MoneyLabel value={data?.reduce((sum, item) => sum + item.value_brl, 0)} currency="BRL" />
          </b>
        </Table.Summary.Cell>
        <Table.Summary.Cell index={4} align="center">
          <b>
            <SimpleRoundedValueLabel value={data?.reduce((sum, item) => sum + item.quantity, 0)} />
          </b>
        </Table.Summary.Cell>
        <Table.Summary.Cell index={5} align="center">
          <b>
            <PercentLabel value={1} decimalPlaces={2} />
          </b>
        </Table.Summary.Cell>
      </Table.Summary.Row>
    </Table.Summary>
  )

  return <Table columns={columns} dataSource={data} pagination={false} summary={footer} size="middle" />
}
